(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gkin-expert-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-expert-carousel]').forEach((root) => {
      const modal = root.querySelector('[data-expert-modal]');
      const host = root.querySelector('[data-expert-video-host]');
      const closeButton = root.querySelector('[data-expert-close]');
      if (!modal || !host) return;

      const closeVideo = () => {
        const video = host.querySelector('video');
        if (video) video.pause();
        host.replaceChildren();
        if (modal.open) modal.close();
      };

      root.querySelectorAll('[data-expert-open]').forEach((card) => {
        card.addEventListener('click', () => {
          const template = card.querySelector('[data-expert-video-template]');
          if (!template) return;
          host.replaceChildren(template.content.cloneNode(true));
          modal.showModal();
          const video = host.querySelector('video');
          if (video) {
            video.muted = false;
            video.volume = 1;
            video.play().catch(() => {});
          }
        });
      });

      closeButton?.addEventListener('click', closeVideo);
      modal.addEventListener('close', () => {
        const video = host.querySelector('video');
        if (video) video.pause();
        host.replaceChildren();
      });
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeVideo();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
